import { useBrandedVisitorGate } from '#pplx/frontend/apps/ask/hooks/branded-visitor-gate-hooks/useBrandedVisitorGate.js';
import { useHardLoginGateVariation } from '#pplx/frontend/apps/ask/hooks/branded-visitor-gate-hooks/useHardLoginGateVariation.js';
import { useHandleClickPricing } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/useHandleClickPricing.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useGetVisitorInformation } from '#pplx/frontend/apps/ask/queries/visitor-queries/useGetVisitorInformation.js';
import { useStudentPaywall } from '#pplx/frontend/apps/ask/subscription/hooks/useStudentPaywall.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { useSingularAttribution } from '#pplx/frontend/growth/analytics-singular/SingularAttributionProviderShared.js';
import { useMemo } from 'react';
export const useUpsellActionSubscriptionRuntime = () => {
    const reason = 'upsell';
    const isUserLoggedIn = useIsUserLoggedIn();
    const { openVisitorLoginUpsell } = useBrandedVisitorGate({
        enabled: !isUserLoggedIn,
    });
    const openPaywallUpsell = usePaywallUpsell();
    const { handleClickPersonal } = useHandleClickPricing({
        reason: 'subscription-promo-description',
    });
    const { handleVerificationSuccess } = useStudentPaywall({
        origin: ModalOrigin.STUDENT_VERIFICATION_UPSELL,
        openVisitorLoginUpsell,
        openPaywallUpsell,
        handleClickPersonal,
    });
    const { subscriptionTier, hasActiveSubscription } = useIsSubscribed();
    const { data: visitorInfo } = useGetVisitorInformation({ reason });
    const visitorDailyQueryCount = visitorInfo?.visitor_queries_past_day;
    const { variation: hardLoginGateVariation } = useHardLoginGateVariation({
        visitorDailyQueryCount,
    });
    const { sendSubscribedEventSingular } = useSingularAttribution();
    return useMemo(() => ({
        handleClickPersonal,
        handleVerificationSuccess,
        hardLoginGateVariation,
        hasActiveSubscription,
        openPaywallUpsell,
        openVisitorLoginUpsell,
        sendSubscribedEventSingular,
        subscriptionTier,
    }), [
        handleClickPersonal,
        handleVerificationSuccess,
        hardLoginGateVariation,
        hasActiveSubscription,
        openPaywallUpsell,
        openVisitorLoginUpsell,
        sendSubscribedEventSingular,
        subscriptionTier,
    ]);
};
//# sourceMappingURL=useUpsellActionSubscriptionRuntime.js.map